import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Label,
  Form,
  FormGroup,
  FormField,
  Checkbox,
  Dropdown,
  Radio
} from 'semantic-ui-react'

const CardSkinPreparationUX = (props: any) => {
    return(
      <div
        id="CardSkinPreparation"
        style={{ margin: "15px",  padding: "20px",  backgroundColor: "rgba(198, 235, 243, 0.2)" }}>
        <div
          id="CardSkinPreparationUX-div-1"
          style={{ paddingBottom: "5px" }}>
          
          <label
            id="CardSkinPreparationUX-label-2"
            style={{ fontWeight: "bold", fontSize: "18px" }}>
            {props.languageUX === "en" ? "Skin Preparation" : "การเตรียมผิว"}
          </label>
          <Label
            color={props.statusColor}
            id="CardSkinPreparationUX-Label-3"
            style={{display: props.config?.hideStatus ? "none" : "", float: "right" }}>
            {props.status}
          </Label>
          <hr
            id="CardSkinPreparationUX-hr-4">
          </hr>
        </div>
        <div
          id="CardSkinPreparationUX-div-230"
          style={{display: "flex"}}>
          
          <div
            className="ui form"
            id="CardSkinPreparationUX-div-243"
            style={{ marginTop: "13px" }}>
            
            <FormGroup
              id="CardSkinPreparationUX-FormGroup-234"
              inline={true}>
              <FormField
                className="required"
                id="CardSkinPreparationUX-FormField-235"
                inline={true}>
                <label
                  id="CardSkinPreparationUX-label-238"
                  style={{minWidth: "135px", maxWidth: "135px"}}>
                  {props.languageUX === "en" ? "Surgical Skin scrub" : "การขัดผิวด้วยการผ่าตัด"}
                </label>
              </FormField>
              <FormField
                id="CardSkinPreparationUX-FormField-236"
                inline={true}>
                <Checkbox
                  checked={props.isSurgicalSkinScrub || false}
                  id="CardSkinPreparationUX-Checkbox-240"
                  label={props.isSurgicalSkinScrub ? "Yes" : "No"}
                  name="is_surgical_skin_scrub"
                  onChange={props.onChangeData}
                  style={{marginRight: "1rem"}}
                  toggle={true}>
                </Checkbox>
              </FormField>
              <FormField
                id="CardSkinPreparationUX-FormField-237"
                inline={true}
                style={!props.isSurgicalSkinScrub ? {display: "none"} : {}}>
                <label
                  id="CardSkinPreparationUX-label-239">
                  {props.languageUX === "en" ? "Scrub skin area of" : "ขัดผิวบริเวณ"}
                </label>
              </FormField>
            </FormGroup>
          </div>
          <div
            className="ui form"
            id="CardSkinPreparationUX-div-244"
            style={{flex: 1}}>
            
            <FormGroup
              id="CardSkinPreparationUX-FormGroup-233"
              inline={true}>
              <FormField
                id="CardSkinPreparationUX-FormField-241"
                inline={true}
                style={{flex: 1}}>
                <div
                  id="CardSkinPreparationUX-div-242">
                  {props.AddSkinScrub}
                </div>
              </FormField>
            </FormGroup>
          </div>
        </div>
        <div
          id="CardSkinPreparationUX-div-245"
          style={!props.isSurgicalSkinScrub ? {display: "none"} : {display: "flex"}}>
          
          <div
            className="ui form"
            id="CardSkinPreparationUX-div-246"
            style={{ marginTop: "10px", width: "375px" }}>
            
            <FormGroup
              id="CardSkinPreparationUX-FormGroup-248"
              inline={true}
              style={{ display: "flex", justifyContent: "flex-end" }}>
              <FormField
                id="CardSkinPreparationUX-FormField-252"
                inline={true}>
                <label
                  id="CardSkinPreparationUX-label-253">
                  {props.languageUX === "en" ? "Paint Area of" : "พื้นที่ทาสีของ"}
                </label>
              </FormField>
            </FormGroup>
          </div>
          <div
            className="ui form"
            id="CardSkinPreparationUX-div-247"
            style={{flex: 1}}>
            
            <FormGroup
              id="CardSkinPreparationUX-FormGroup-249"
              inline={true}>
              <FormField
                id="CardSkinPreparationUX-FormField-250"
                inline={true}
                style={{flex: 1}}>
                <div
                  id="CardSkinPreparationUX-div-251">
                  {props.AddPaintArea}
                </div>
              </FormField>
            </FormGroup>
          </div>
        </div>
        <Form
          id="CardSkinPreparationUX-Form-179">
          <FormGroup
            id="CardSkinPreparationUX-FormGroup-227"
            inline={true}
            style={{display: "none"}}>
            <FormField
              id="CardSkinPreparationUX-FormField-184"
              inline={true}
              style={{minWidth: "max-content"}}>
              <Checkbox
                checked={props.isSurgicalSite || false}
                id="CardSkinPreparationUX-Checkbox-195"
                label={props.languageUX === "en" ? "Surgical site" : "บริเวณผ่าตัด"}
                name="is_surgical_site"
                onChange={props.onChangeData}>
              </Checkbox>
            </FormField>
            <FormField
              id="CardSkinPreparationUX-FormField-185"
              inline={true}
              style={{minWidth: "max-content"}}>
              <div
                id="CardSkinPreparationUX-div-226">
                {props.languageUX === "en" ? "Solution" : "สารละลาย"}
              </div>
            </FormField>
            <FormField
              id="CardSkinPreparationUX-FormField-186"
              inline={true}
              width={12}>
              <Dropdown
                allowAdditions={true}
                clearable={true}
                fluid={true}
                id="CardSkinPreparationUX-Dropdown-197"
                multiple={true}
                name="vagina"
                onAddItem={props.handleAddVaginaOptions}
                onChange={props.onChangeData}
                options={props.orVaginaOptions || []}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.vagina || []}>
              </Dropdown>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardSkinPreparationUX-FormGroup-181"
            inline={true}>
            <FormField
              className="required"
              id="CardSkinPreparationUX-FormField-187"
              inline={true}>
              <label
                id="CardSkinPreparationUX-label-203"
                style={{minWidth: "135px", maxWidth: "135px"}}>
                {props.languageUX === "en" ? "Wound Classification" : "การจำแนกประเภทของบาดแผล"}
              </label>
            </FormField>
            <FormField
              id="CardSkinPreparationUX-FormField-188"
              inline={true}>
              <Radio
                checked={props.woundClassification === "clean"}
                id="CardSkinPreparationUX-Radio-202"
                label={props.languageUX === "en" ? "Clean" : "ทำความสะอาด"}
                onChange={(e: any)=>props.onChangeData?.(e,{value: "clean", name: "wound_classification"})}>
              </Radio>
            </FormField>
            <FormField
              id="CardSkinPreparationUX-FormField-189"
              inline={true}>
              <Radio
                checked={props.woundClassification === "clean_contaminated"}
                id="CardSkinPreparationUX-Radio-201"
                label={props.languageUX === "en" ? "Clean-contaminated" : "ปนเปื้อนสะอาด"}
                onChange={(e: any)=>props.onChangeData?.(e,{value: "clean_contaminated", name: "wound_classification"})}>
              </Radio>
            </FormField>
            <FormField
              id="CardSkinPreparationUX-FormField-190"
              inline={true}>
              <Radio
                checked={props.woundClassification === "contaminated"}
                id="CardSkinPreparationUX-Radio-200"
                label={props.languageUX === "en" ? "Contaminated" : "ปนเปื้อน"}
                onChange={(e: any)=>props.onChangeData?.(e,{value: "contaminated", name: "wound_classification"})}>
              </Radio>
            </FormField>
            <FormField
              id="CardSkinPreparationUX-FormField-191"
              inline={true}>
              <Radio
                checked={props.woundClassification === "infected"}
                id="CardSkinPreparationUX-Radio-199"
                label={props.languageUX === "en" ? "Infected" : "ติดเชื้อแล้ว"}
                onChange={(e: any)=>props.onChangeData?.(e,{value: "infected", name: "wound_classification"})}>
              </Radio>
            </FormField>
            <FormField
              id="CardSkinPreparationUX-FormField-192"
              inline={true}>
              <Radio
                checked={props.woundClassification === "scope"}
                id="CardSkinPreparationUX-Radio-198"
                label={props.languageUX === "en" ? "Scope" : "ขอบเขต"}
                onChange={(e: any)=>props.onChangeData?.(e,{value: "scope", name: "wound_classification"})}>
              </Radio>
            </FormField>
          </FormGroup>
        </Form>
        <div
          id="CardSkinPreparationUX-div-254"
          style={{width: "100%"}}>
          {props.nursingDiagnosisItem}
        </div>
        <div
          id="CardSkinPreparationUX-div-154"
          style={{ height: "55px", paddingTop: "15px" }}>
          
          <div
            id="CardSkinPreparationUX-div-155"
            style={{ float: "right" , display: "flex"}}>
            
            <div
              id="CardSkinPreparationUX-div-176"
              style={{margin: "0 0.25rem"}}>
              {props.ButtonSave}
            </div>
            <div
              id="CardSkinPreparationUX-div-177"
              style={{margin: "0 0.25rem"}}>
              {props.ButtonConfirm}
            </div>
            <div
              id="CardSkinPreparationUX-div-178"
              style={{margin: "0 0.25rem"}}>
              {props.ButtonUnConfirm}
            </div>
          </div>
        </div>
      </div>
    )
}


export default CardSkinPreparationUX

export const screenPropsDefault = {}

/* Date Time : Mon Aug 18 2025 09:30:53 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSkinPreparation"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"15px\",  padding: \"20px\",  backgroundColor: \"rgba(198, 235, 243, 0.2)\" }"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSkinPreparationUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{ paddingBottom: \"5px\" }"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "label",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": "การเตรียมผิว",
          "valueEN": "Skin Preparation"
        },
        "id": {
          "type": "value",
          "value": "CardSkinPreparationUX-label-2"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", fontSize: \"18px\" }"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 3,
      "name": "Label",
      "parent": 1,
      "props": {
        "children": {
          "type": "code",
          "value": "props.status"
        },
        "color": {
          "type": "code",
          "value": "props.statusColor"
        },
        "id": {
          "type": "value",
          "value": "CardSkinPreparationUX-Label-3"
        },
        "style": {
          "type": "code",
          "value": "{display: props.config?.hideStatus ? \"none\" : \"\", float: \"right\" }"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "hr",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSkinPreparationUX-hr-4"
        }
      },
      "seq": 4,
      "void": true
    },
    {
      "from": null,
      "id": 154,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSkinPreparationUX-div-154"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"55px\", paddingTop: \"15px\" }"
        }
      },
      "seq": 254,
      "void": false
    },
    {
      "from": null,
      "id": 155,
      "name": "div",
      "parent": 154,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSkinPreparationUX-div-155"
        },
        "style": {
          "type": "code",
          "value": "{ float: \"right\" , display: \"flex\"}"
        }
      },
      "seq": 155,
      "void": false
    },
    {
      "from": null,
      "id": 176,
      "name": "div",
      "parent": 155,
      "props": {
        "children": {
          "type": "code",
          "value": "props.ButtonSave"
        },
        "id": {
          "type": "value",
          "value": "CardSkinPreparationUX-div-176"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0 0.25rem\"}"
        }
      },
      "seq": 176,
      "void": false
    },
    {
      "from": null,
      "id": 177,
      "name": "div",
      "parent": 155,
      "props": {
        "children": {
          "type": "code",
          "value": "props.ButtonConfirm"
        },
        "id": {
          "type": "value",
          "value": "CardSkinPreparationUX-div-177"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0 0.25rem\"}"
        }
      },
      "seq": 177,
      "void": false
    },
    {
      "from": null,
      "id": 178,
      "name": "div",
      "parent": 155,
      "props": {
        "children": {
          "type": "code",
          "value": "props.ButtonUnConfirm"
        },
        "id": {
          "type": "value",
          "value": "CardSkinPreparationUX-div-178"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0 0.25rem\"}"
        }
      },
      "seq": 178,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 179,
      "name": "Form",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSkinPreparationUX-Form-179"
        }
      },
      "seq": 204,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 181,
      "name": "FormGroup",
      "parent": 179,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSkinPreparationUX-FormGroup-181"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 227,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 184,
      "name": "FormField",
      "parent": 227,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSkinPreparationUX-FormField-184"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 184,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 185,
      "name": "FormField",
      "parent": 227,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSkinPreparationUX-FormField-185"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 185,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 186,
      "name": "FormField",
      "parent": 227,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSkinPreparationUX-FormField-186"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "12"
        }
      },
      "seq": 186,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 187,
      "name": "FormField",
      "parent": 181,
      "props": {
        "className": {
          "type": "value",
          "value": "required"
        },
        "id": {
          "type": "value",
          "value": "CardSkinPreparationUX-FormField-187"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 187,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 188,
      "name": "FormField",
      "parent": 181,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSkinPreparationUX-FormField-188"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 188,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 189,
      "name": "FormField",
      "parent": 181,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSkinPreparationUX-FormField-189"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 189,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 190,
      "name": "FormField",
      "parent": 181,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSkinPreparationUX-FormField-190"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 190,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 191,
      "name": "FormField",
      "parent": 181,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSkinPreparationUX-FormField-191"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 191,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 192,
      "name": "FormField",
      "parent": 181,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSkinPreparationUX-FormField-192"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 192,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 195,
      "name": "Checkbox",
      "parent": 184,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.isSurgicalSite || false"
        },
        "id": {
          "type": "value",
          "value": "CardSkinPreparationUX-Checkbox-195"
        },
        "label": {
          "type": "value",
          "value": "บริเวณผ่าตัด",
          "valueEN": "Surgical site"
        },
        "name": {
          "type": "value",
          "value": "is_surgical_site"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 195,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 197,
      "name": "Dropdown",
      "parent": 186,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": ""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSkinPreparationUX-Dropdown-197"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "vagina"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.handleAddVaginaOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.orVaginaOptions || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.vagina || []"
        }
      },
      "seq": 197,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 198,
      "name": "Radio",
      "parent": 192,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.woundClassification === \"scope\""
        },
        "id": {
          "type": "value",
          "value": "CardSkinPreparationUX-Radio-198"
        },
        "label": {
          "type": "value",
          "value": "ขอบเขต",
          "valueEN": "Scope"
        },
        "onChange": {
          "type": "code",
          "value": "(e: any)=>props.onChangeData?.(e,{value: \"scope\", name: \"wound_classification\"})"
        }
      },
      "seq": 198,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 199,
      "name": "Radio",
      "parent": 191,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.woundClassification === \"infected\""
        },
        "id": {
          "type": "value",
          "value": "CardSkinPreparationUX-Radio-199"
        },
        "label": {
          "type": "value",
          "value": "ติดเชื้อแล้ว",
          "valueEN": "Infected"
        },
        "onChange": {
          "type": "code",
          "value": "(e: any)=>props.onChangeData?.(e,{value: \"infected\", name: \"wound_classification\"})"
        }
      },
      "seq": 199,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 200,
      "name": "Radio",
      "parent": 190,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.woundClassification === \"contaminated\""
        },
        "id": {
          "type": "value",
          "value": "CardSkinPreparationUX-Radio-200"
        },
        "label": {
          "type": "value",
          "value": "ปนเปื้อน",
          "valueEN": "Contaminated"
        },
        "onChange": {
          "type": "code",
          "value": "(e: any)=>props.onChangeData?.(e,{value: \"contaminated\", name: \"wound_classification\"})"
        }
      },
      "seq": 200,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 201,
      "name": "Radio",
      "parent": 189,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.woundClassification === \"clean_contaminated\""
        },
        "id": {
          "type": "value",
          "value": "CardSkinPreparationUX-Radio-201"
        },
        "label": {
          "type": "value",
          "value": "ปนเปื้อนสะอาด",
          "valueEN": "Clean-contaminated"
        },
        "onChange": {
          "type": "code",
          "value": "(e: any)=>props.onChangeData?.(e,{value: \"clean_contaminated\", name: \"wound_classification\"})"
        }
      },
      "seq": 201,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 202,
      "name": "Radio",
      "parent": 188,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.woundClassification === \"clean\""
        },
        "id": {
          "type": "value",
          "value": "CardSkinPreparationUX-Radio-202"
        },
        "label": {
          "type": "value",
          "value": "ทำความสะอาด",
          "valueEN": "Clean"
        },
        "onChange": {
          "type": "code",
          "value": "(e: any)=>props.onChangeData?.(e,{value: \"clean\", name: \"wound_classification\"})"
        }
      },
      "seq": 202,
      "void": false
    },
    {
      "from": null,
      "id": 203,
      "name": "label",
      "parent": 187,
      "props": {
        "children": {
          "type": "value",
          "value": "การจำแนกประเภทของบาดแผล",
          "valueEN": "Wound Classification"
        },
        "id": {
          "type": "value",
          "value": "CardSkinPreparationUX-label-203"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"135px\", maxWidth: \"135px\"}"
        }
      },
      "seq": 203,
      "void": false
    },
    {
      "from": null,
      "id": 226,
      "name": "div",
      "parent": 185,
      "props": {
        "children": {
          "type": "value",
          "value": "สารละลาย",
          "valueEN": "Solution"
        },
        "id": {
          "type": "value",
          "value": "CardSkinPreparationUX-div-226"
        }
      },
      "seq": 226,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 227,
      "name": "FormGroup",
      "parent": 179,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSkinPreparationUX-FormGroup-227"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: \"none\"}"
        }
      },
      "seq": 181,
      "void": false
    },
    {
      "from": null,
      "id": 230,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSkinPreparationUX-div-230"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\"}"
        }
      },
      "seq": 139,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 233,
      "name": "FormGroup",
      "parent": 244,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSkinPreparationUX-FormGroup-233"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 233,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 234,
      "name": "FormGroup",
      "parent": 243,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSkinPreparationUX-FormGroup-234"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 234,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 235,
      "name": "FormField",
      "parent": 234,
      "props": {
        "className": {
          "type": "value",
          "value": "required"
        },
        "id": {
          "type": "value",
          "value": "CardSkinPreparationUX-FormField-235"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 235,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 236,
      "name": "FormField",
      "parent": 234,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSkinPreparationUX-FormField-236"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 236,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 237,
      "name": "FormField",
      "parent": 234,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSkinPreparationUX-FormField-237"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "!props.isSurgicalSkinScrub ? {display: \"none\"} : {}"
        }
      },
      "seq": 237,
      "void": false
    },
    {
      "from": null,
      "id": 238,
      "name": "label",
      "parent": 235,
      "props": {
        "children": {
          "type": "value",
          "value": "การขัดผิวด้วยการผ่าตัด",
          "valueEN": "Surgical Skin scrub"
        },
        "id": {
          "type": "value",
          "value": "CardSkinPreparationUX-label-238"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"135px\", maxWidth: \"135px\"}"
        }
      },
      "seq": 238,
      "void": false
    },
    {
      "from": null,
      "id": 239,
      "name": "label",
      "parent": 237,
      "props": {
        "children": {
          "type": "value",
          "value": "ขัดผิวบริเวณ",
          "valueEN": "Scrub skin area of"
        },
        "id": {
          "type": "value",
          "value": "CardSkinPreparationUX-label-239"
        }
      },
      "seq": 239,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 240,
      "name": "Checkbox",
      "parent": 236,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.isSurgicalSkinScrub || false"
        },
        "id": {
          "type": "value",
          "value": "CardSkinPreparationUX-Checkbox-240"
        },
        "label": {
          "type": "code",
          "value": "props.isSurgicalSkinScrub ? \"Yes\" : \"No\""
        },
        "name": {
          "type": "value",
          "value": "is_surgical_skin_scrub"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"1rem\"}"
        },
        "toggle": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 240,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 241,
      "name": "FormField",
      "parent": 233,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSkinPreparationUX-FormField-241"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{flex: 1}"
        }
      },
      "seq": 241,
      "void": false
    },
    {
      "from": null,
      "id": 242,
      "name": "div",
      "parent": 241,
      "props": {
        "children": {
          "type": "code",
          "value": "props.AddSkinScrub"
        },
        "id": {
          "type": "value",
          "value": "CardSkinPreparationUX-div-242"
        }
      },
      "seq": 242,
      "void": false
    },
    {
      "from": null,
      "id": 243,
      "name": "div",
      "parent": 230,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardSkinPreparationUX-div-243"
        },
        "style": {
          "type": "code",
          "value": "{ marginTop: \"13px\" }"
        }
      },
      "seq": 243,
      "void": false
    },
    {
      "from": null,
      "id": 244,
      "name": "div",
      "parent": 230,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardSkinPreparationUX-div-244"
        },
        "style": {
          "type": "code",
          "value": "{flex: 1}"
        }
      },
      "seq": 244,
      "void": false
    },
    {
      "from": null,
      "id": 245,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSkinPreparationUX-div-245"
        },
        "style": {
          "type": "code",
          "value": "!props.isSurgicalSkinScrub ? {display: \"none\"} : {display: \"flex\"}"
        }
      },
      "seq": 179,
      "void": false
    },
    {
      "from": null,
      "id": 246,
      "name": "div",
      "parent": 245,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardSkinPreparationUX-div-246"
        },
        "style": {
          "type": "code",
          "value": "{ marginTop: \"10px\", width: \"375px\" }"
        }
      },
      "seq": 246,
      "void": false
    },
    {
      "from": null,
      "id": 247,
      "name": "div",
      "parent": 245,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardSkinPreparationUX-div-247"
        },
        "style": {
          "type": "code",
          "value": "{flex: 1}"
        }
      },
      "seq": 247,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 248,
      "name": "FormGroup",
      "parent": 246,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSkinPreparationUX-FormGroup-248"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"flex-end\" }"
        }
      },
      "seq": 248,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 249,
      "name": "FormGroup",
      "parent": 247,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSkinPreparationUX-FormGroup-249"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 249,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 250,
      "name": "FormField",
      "parent": 249,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSkinPreparationUX-FormField-250"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{flex: 1}"
        }
      },
      "seq": 250,
      "void": false
    },
    {
      "from": null,
      "id": 251,
      "name": "div",
      "parent": 250,
      "props": {
        "children": {
          "type": "code",
          "value": "props.AddPaintArea"
        },
        "id": {
          "type": "value",
          "value": "CardSkinPreparationUX-div-251"
        }
      },
      "seq": 251,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 252,
      "name": "FormField",
      "parent": 248,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSkinPreparationUX-FormField-252"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 252,
      "void": false
    },
    {
      "from": null,
      "id": 253,
      "name": "label",
      "parent": 252,
      "props": {
        "children": {
          "type": "value",
          "value": "พื้นที่ทาสีของ",
          "valueEN": "Paint Area of"
        },
        "id": {
          "type": "value",
          "value": "CardSkinPreparationUX-label-253"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 253,
      "void": false
    },
    {
      "from": null,
      "id": 254,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.nursingDiagnosisItem"
        },
        "id": {
          "type": "value",
          "value": "CardSkinPreparationUX-div-254"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 230,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 85,
  "isMounted": false,
  "memo": false,
  "name": "CardSkinPreparationUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
